<template>
	<div class="recharge-page   ">
		<div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('assestLog.label1') }} </div>
		<div class="recharge-main">
			<div class="left-content">
				<div class="title">{{ $t('chong-zhi-bi-zhong') }}</div>
				<div class="sub-title">{{ $t('qing-dian-ji-xia-fang-xu-yao-chong-zhi-de-bi-zhong') }}</div>
				<div class="recharge-list">
					<div class="list" v-for="(item, i) in availableRechargeList" :key="i" :class="[i < 2 ? 'big' : '', rechargeInfo.key == item.key ? 'active' : '']" @click="chooseBit(item)">
						<div class="name">
							<img :src="item.icon" alt="">
							<span>{{item.name}}</span>
						</div>
					</div>
				</div>

				<div class="address-box" v-show="rechargeInfo.address">
					<div class="label">{{ $t('chong-bi-er-wei-ma') }}</div>
					<div class="qrcode flex-center" >
						<div ref="qrcode" id="qrcode"></div>
					</div>
					<div class="label">{{i18n.t('recharge.label2')}}</div>
					<div class="address flex-center-start">
						<div class="info ">{{rechargeInfo.address}}</div>
						<div class="flex-center-end  copy-icon" @click="copyData">
							<img :src="copyUrl" alt="">
						</div>
					</div>
				</div>

				<!-- 充值申请表单 -->
				<div class="recharge-application">
					<div class="application-title">{{ i18n.t('recharge.chong_zhi_shen_qing') }}</div>
					<div class="form-content">
						<div class="form-item">
							<div class="label">{{ i18n.t('recharge.chong_zhi_shu_liang') }}</div>
							<input
								type="text"
								v-model="applyForm.amount"
								:placeholder="i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang')"
								@input="handleAmountInput"
							>
							<div class="conversion-preview" v-if="isAutoExchangeRecharge">
								<div class="conversion-title">{{ i18n.t('recharge.auto_exchange_title', [conversionSourceName]) }}</div>
								<div class="conversion-text" v-if="conversionRateLoading">{{ i18n.t('recharge.auto_exchange_loading') }}</div>
								<template v-else>
									<div class="conversion-amount" v-if="conversionPreviewAmount">
										{{ i18n.t('recharge.auto_exchange_estimated') }}
										<span>{{ conversionPreviewAmount }} USDT</span>
									</div>
									<div class="conversion-text" v-else>{{ i18n.t('recharge.auto_exchange_input_tip') }}</div>
									<div class="conversion-text" v-if="conversionRate">
										{{ i18n.t('recharge.auto_exchange_rate', [conversionSourceName, formattedConversionRate]) }}
									</div>
									<div class="conversion-text warning" v-else>{{ i18n.t('recharge.auto_exchange_unavailable') }}</div>
									<div class="conversion-text">{{ i18n.t('recharge.auto_exchange_confirm_tip') }}</div>
								</template>
							</div>
						</div>
						<div class="form-item">
							<div class="label">{{ i18n.t('recharge.zhi_fu_ping_zheng') }} <span class="required">*</span></div>
							<div class="upload-container">
								<div class="upload-button" @click="triggerFileInput">
									<img :src="uploadIcon" alt="" v-if="!applyForm.paymentVoucher && !applyForm.uploadedImage">
									<span v-if="!applyForm.paymentVoucher && !applyForm.uploadedImage">{{ i18n.t('recharge.shang_chuan_ping_zheng') }}</span>
									<!-- 本地预览图片 -->
									<img :src="applyForm.uploadedImage" alt="上传的图片" v-if="applyForm.uploadedImage && !applyForm.paymentVoucher" class="preview-image">
									<!-- 服务器图片 -->
									<img :src="getServerImageUrl(applyForm.paymentVoucher)" alt="上传的图片" v-if="applyForm.paymentVoucher" class="preview-image">
								</div>
								<input 
									type="file" 
									ref="fileInput" 
									style="display: none" 
									accept="image/*"
									@change="handleFileUpload"
								>
								<div class="upload-tip" v-if="!applyForm.paymentVoucher && !applyForm.uploadedImage">
									{{ i18n.t('recharge.upload_tip') }}
								</div>
								<div class="upload-actions" v-if="applyForm.paymentVoucher || applyForm.uploadedImage">
									<button class="view-btn" @click="viewImage">{{ i18n.t('recharge.view_image') }}</button>
									<button class="remove-btn" @click="removeImage">{{ i18n.t('recharge.remove_image') }}</button>
								</div>
							</div>
						</div>
						<div class="form-btn">
							<button @click="submitRechargeApplication" :disabled="!isFormValid" :class="{'disabled': !isFormValid}">
								{{ i18n.t('recharge.ti_jiao_shen_qing') }}
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="right-content">
				<div class="recharge-warning">
					<div class="title">{{i18n.t('recharge.label4')}}</div>
					<div class="info">{{ $t('recharge.desc1', [rechargeInfo.name]) }}</div>
					<div class="info">{{ $t('recharge.desc2', [rechargeInfo.min]) }}</div>
					<div class="info">{{$t('recharge.desc3')}}</div>
				</div>
			</div>
		</div>

		<div class="space-line"></div>

		<div class="page-title">{{ $t('quan-bu-chong-bi-ji-lu') }}</div>

		<div class="list-table clear-bg">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t('chong-zhi-bi-zhong-0') }}</div>
        <div class="th flex-2">{{ $t('chart_page.time') }}</div>
        <div class="th flex-2">{{ $t('recharge.label2') }}</div>
        <div class="th flex-2">{{ $t('chong-zhi-shu-liang') }}</div>
        <div class="th action">{{ $t('finance.label12') }}</div>
      </div>
      <div class="tbody">
        <div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
          <div class="td flex-2 flex-center-start">
            <img :src="item.Currency && item.Currency.Logo ? '/upload/' + item.Currency.Logo : ''" alt="">
            <span>{{item.Currency && item.Currency.ShortName || ''}}</span>
          </div>
          <div class="td flex-2">{{item.CreatedAt || ''}}</div>
          <div class="td flex-2">{{item.Addresss || ''}}</div>
          <div class="td flex-2">{{item.Practical ? parseFloat(item.Practical).toFixed(4) : '0.0000'}}</div>
          <div class="td action flex-center">
            <span class="point" :class="getStatusClass(item.Status)"></span>
            {{getStatusText(item.Status)}}
          </div>
        </div>
        <div class="empty-data" v-if="logList.length === 0">
          <p>{{i18n.t('recharge.no_records')}}</p>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>


	</div>
</template>
<script>
import { applyPay, debtLog, rechargeAddress, wallet } from '@/api/assest'
import { getExchangeRate } from '@/api/index'
import { Popup, Button, Dialog } from 'vant'
import Clipboard from 'clipboard';
import QRCode from 'qrcodejs2'
import { uploadFile } from '@/api/setting'
import pageBar from '@/components/pageBar'
import {
	calculateRechargeConversion,
	findRechargeConversionRate,
	protocolToShortName,
	shouldAutoExchangeRecharge
} from '@/utils/rechargeConversion'
export default {
	components: {
    Popup,
    Button,
		pageBar
  },
  data() {
		return {
			backUrl: require('../../assets/imgs/icon-back.png'),
			copyUrl: require('../../assets/imgs/icon-copy.png'),
			uploadIcon: require('../../assets/imgs/icon-recharge.png'),
			showRecharge: false,
			showAccount: false,
			rechargeAddressData: {},
			accountName: '',
      allCoinTypes: [
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-TRC20',
					key: 'USDT-TRC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-ERC20',
					key: 'USDT-ERC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit3.png'),
					name: 'ETH-ERC20',
					key: 'ETH-ERC20',
					min: 0.02
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDC-TRC20',
					key: 'USDC-TRC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDC-ERC20',
					key: 'USDC-ERC20',
					min: 1
				},
				{
					icon: require('../../assets/imgs/bit4.png'),
					name: 'BTC',
					key: 'Bitcoin',
					min: 0.0002
				},
			],
			availableRechargeList: [],
			rechargeInfo: {},
			address: '',
			addressData: {},
			page: {
				page: 1,
				limit: 10,
				total: 1
			},
			logList: [],
			conversionRate: null,
			conversionRateLoading: false,
			applyForm: {
				amount: '',
				paymentVoucher: '',
				uploadedImage: '',
				fileData: null
			}
		}
	},
	computed: {
		isFormValid() {
			const numericAmount = this.convertAmountToNumber(this.applyForm.amount);
			return numericAmount && this.applyForm.fileData && this.rechargeInfo.address;
		},
		isAutoExchangeRecharge() {
			return shouldAutoExchangeRecharge(this.rechargeInfo.key);
		},
		conversionSourceName() {
			return protocolToShortName(this.rechargeInfo.key);
		},
		normalizedApplyAmount() {
			return this.convertAmountToNumber(this.applyForm.amount);
		},
		conversionPreviewAmount() {
			return calculateRechargeConversion(this.normalizedApplyAmount, this.conversionRate);
		},
		formattedConversionRate() {
			return this.conversionRate ? Number(this.conversionRate).toFixed(4) : '';
		}
	},
  mounted() {
		this.init()
		this.initLog()
	},
	methods: {
		handleAmountInput(event) {
			const oldValue = this.applyForm.amount || '';
			let value = event.target.value;

			// 只允许数字、逗号和小数点，具体语义在提交时再转换
			value = value.replace(/[^0-9,\.]/g, '');

			// 不允许只输入一个分隔符作为开头
			if (value.length === 1 && (value === '.' || value === ',')) {
				value = '';
			}

			const hasComma = value.includes(',');
			const hasDot = value.includes('.');
			const dotCount = (value.match(/\./g) || []).length;
			const commaCount = (value.match(/,/g) || []).length;

			// 场景一：只有点，没有逗号时，点视为小数点，只允许一个
			if (!hasComma && dotCount > 1) {
				this.applyForm.amount = oldValue;
				event.target.value = oldValue;
				return;
			}

			// 场景二：只有逗号，没有点时，逗号既可能是小数点也可能是千分位
			// 允许多个逗号，但每一组长度最多 3 位，且仅包含数字，避免明显异常格式
			if (!hasDot && commaCount > 1) {
				const parts = value.split(',');
				let ok = true;
				for (let i = 0; i < parts.length; i++) {
					if (!/^\d*$/.test(parts[i])) {
						ok = false;
						break;
					}
					// 第一段 1~3 位，其余每段最多 3 位（用于兼容正在输入中的长金额）
					if (i === 0) {
						if (parts[i].length > 3) {
							ok = false;
							break;
						}
					} else {
						if (parts[i].length > 3) {
							ok = false;
							break;
						}
					}
				}
				if (!ok) {
					this.applyForm.amount = oldValue;
					event.target.value = oldValue;
					return;
				}
			}

			// 场景三：同时存在逗号和点，需要区分小数点和千分位
			if (hasComma && hasDot) {
				const lastComma = value.lastIndexOf(',');
				const lastDot = value.lastIndexOf('.');
				const decimalSep = lastComma > lastDot ? ',' : '.';
				const reg = new RegExp('\\' + decimalSep, 'g');
				const decCount = (value.match(reg) || []).length;
				// 小数分隔符只能出现一次，例如：禁止 1,231.12.123
				if (decCount > 1) {
					this.applyForm.amount = oldValue;
					event.target.value = oldValue;
					return;
				}
			}

			this.applyForm.amount = value;
		},
		// 将显示格式转换为数字格式（用于提交）
		convertAmountToNumber(amountStr) {
			if (!amountStr) return '';

			// 去掉空格，只保留数字、逗号和小数点
			let value = amountStr.replace(/\s/g, '').replace(/[^0-9,\.]/g, '');

			const hasComma = value.includes(',');
			const hasDot = value.includes('.');

			if (hasComma && hasDot) {
				// 同时存在逗号和小数点：
				// 先根据最后出现的位置判定小数分隔符，再校验千分位分组是否合法
				const lastComma = value.lastIndexOf(',');
				const lastDot = value.lastIndexOf('.');
				const decimalSep = lastComma > lastDot ? ',' : '.';
				const thousandSep = decimalSep === ',' ? '.' : ',';

				// 小数分隔符只能出现一次
				if (value.split(decimalSep).length > 2) {
					return '';
				}

				const partsByDecimal = value.split(decimalSep);
				const intPartRaw = partsByDecimal[0];
				const fracPartRaw = partsByDecimal[1] || '';

				// 校验整数部分千分位分组（如 12,345,678 或 1.234.567）
				let intDigits = intPartRaw;
				if (intPartRaw.includes(thousandSep)) {
					const segs = intPartRaw.split(thousandSep);
					// 第一段 1~3 位，其余必须是 3 位
					if (!segs[0] || segs[0].length > 3) {
						return '';
					}
					for (let i = 1; i < segs.length; i++) {
						if (segs[i].length !== 3) {
							return '';
						}
					}
					intDigits = segs.join('');
				}

				// 整数、小数部分都只能是数字
				if (!/^\d+$/.test(intDigits)) {
					return '';
				}
				if (fracPartRaw && !/^\d+$/.test(fracPartRaw)) {
					return '';
				}

				// 组装为统一的小数点格式，后面再统一限制最多 4 位小数
				value = intDigits + (fracPartRaw ? '.' + fracPartRaw : '');
			} else if (hasComma) {
				// 只有逗号时，根据分组判断是千分位还是小数点
				const parts = value.split(',');
				const allThree = parts.slice(1).every(p => p.length === 3);
				if (allThree && parts.length > 1 && parts[parts.length - 1].length === 3) {
					// 形如 1,234 或 1,234,567 => 逗号为千分位
					value = parts.join('');
				} else {
					// 形如 123,12 => 逗号为小数点
					value = value.replace(/,/g, '.');
				}
			} else if (hasDot) {
				// 只有小数点时，同样根据分组判断是否为千分位
				const parts = value.split('.');
				const allThree = parts.slice(1).every(p => p.length === 3);
				if (allThree && parts.length > 1 && parts[parts.length - 1].length === 3) {
					// 形如 1.234 或 1.234.567 => 点为千分位
					value = parts.join('');
				} else {
					// 常规小数点小数，保持不变
				}
			}

			// 现在只允许「数字」或「数字.数字」格式
			if (!/^\d+(\.\d+)?$/.test(value)) {
				return '';
			}

			// 限制最多 4 位小数，多余部分截断
			const parts = value.split('.');
			if (parts.length === 2 && parts[1].length > 4) {
				value = parts[0] + '.' + parts[1].substring(0, 4);
			}

			return value;
		},
		init() {
			rechargeAddress().then(res => {
				this.rechargeAddressData = res.data
				// 过滤出有地址的充值选项
				this.availableRechargeList = this.allCoinTypes.filter(coin => {
					return this.rechargeAddressData[coin.key] && this.rechargeAddressData[coin.key] !== '';
				}).map(coin => {
					return {
						...coin,
						address: this.rechargeAddressData[coin.key]
					};
				});
				
				// 如果有可用的充值选项，选择第一个
				if (this.availableRechargeList.length > 0) {
					this.rechargeInfo = this.availableRechargeList[0];
					this.refreshRechargeConversionRate();
					// 初始化二维码
					this.$nextTick(() => {
						this.generateQRCode(this.rechargeInfo);
					});
				}
			})
    },
		changePage(page) {
      this.page.page = page
      this.initLog()
    },
		initLog() {
			let form = new FormData()
			form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      form.append('CurrencyType', '')
      form.append('Type', '')
      form.append('MultiType', '4')  // 充值记录类型
      form.append('CurrencyId', '')
      debtLog(form).then(res => {
				this.logList = res.data.Items || []
				this.page.total = res.data.Pagination ? res.data.Pagination.totalRecords : 0
			}).catch(err => {
				console.error('获取充值记录失败:', err)
				this.logList = []
				this.page.total = 0
			})
		},
		back() {
			this.$router.go(-1)
		},
		cancel() {
			this.showRecharge = false
		},
		copyData() {
      let data = this.rechargeInfo.address
      const clipboard = new Clipboard('.copy-icon', {text: () => data});
      this.$toast.success(this.i18n.t('recharge.success'))
    },
		chooseBit(data) {
			this.rechargeInfo = data
			this.generateQRCode(data);
			this.refreshRechargeConversionRate();
		},
		refreshRechargeConversionRate() {
			const protocol = this.rechargeInfo.key;
			if (!shouldAutoExchangeRecharge(protocol)) {
				this.conversionRate = null;
				this.conversionRateLoading = false;
				return;
			}

			this.conversionRateLoading = true;
			Promise.all([
				wallet({ current: 1, pageSize: 200 }),
				getExchangeRate({})
			]).then(([walletRes, tradeRes]) => {
				if (this.rechargeInfo.key !== protocol) return;

				const walletRows = walletRes.data && walletRes.data.Items ? walletRes.data.Items : [];
				const tradeRows = tradeRes.data || [];
				this.conversionRate = findRechargeConversionRate(protocol, walletRows, tradeRows);
			}).catch(err => {
				console.error('获取充值兑换汇率失败:', err);
				this.conversionRate = null;
			}).finally(() => {
				if (this.rechargeInfo.key === protocol) {
					this.conversionRateLoading = false;
				}
			});
		},
		generateQRCode(data) {
			document.getElementById('qrcode').innerHTML = ''
			new QRCode(this.$refs.qrcode, {
				text: data.address,
				width: 110,
				height: 110,
				correctLevel: QRCode.CorrectLevel.H
			})
		},
		triggerFileInput() {
			this.$refs.fileInput.click();
		},
		handleFileUpload(event) {
			const file = event.target.files[0];
			if (!file) return;
			
			// 检查文件类型
			if (!file.type.includes('image/')) {
				this.$toast.fail(this.i18n.t('recharge.file_type_error'));
				return;
			}
			
			// 检查文件大小，限制为5MB
			if (file.size > 5 * 1024 * 1024) {
				this.$toast.fail(this.i18n.t('recharge.file_size_error'));
				return;
			}
			
			// 存储文件数据，用于后续上传
			this.applyForm.fileData = file;
			
			// 创建预览
			const reader = new FileReader();
			reader.onload = (e) => {
				this.applyForm.uploadedImage = e.target.result;
				// 重置之前可能存在的服务器文件路径
				this.applyForm.paymentVoucher = '';
			};
			reader.readAsDataURL(file);
		},
		viewImage() {
			let imageUrl = '';
			if (this.applyForm.paymentVoucher) {
				// 使用服务器上的图片
				imageUrl = this.getServerImageUrl(this.applyForm.paymentVoucher);
			} else if (this.applyForm.uploadedImage) {
				// 使用本地预览图片
				imageUrl = this.applyForm.uploadedImage;
			}
			
			if (imageUrl) {
				Dialog.alert({
					message: `<div class="image-preview-dialog"><img src="${imageUrl}" /></div>`,
					className: 'image-dialog',
					messageAlign: 'center'
				}).catch(() => {});
			}
		},
		removeImage() {
			this.applyForm.uploadedImage = '';
			this.applyForm.paymentVoucher = '';
			this.applyForm.fileData = null;
			this.$refs.fileInput.value = '';
		},
		getServerImageUrl(fileName) {
			if (!fileName) return '';
			return `/upload/tmp/${fileName}`;
		},
		uploadPaymentVoucher() {
			return new Promise((resolve, reject) => {
				if (!this.applyForm.fileData) {
					reject(new Error(this.i18n.t('recharge.please_upload_image')));
					return;
				}
				
				const formData = new FormData();
				formData.append('file', this.applyForm.fileData);
				
				this.$toast.loading({
					message: this.i18n.t('recharge.uploading'),
					forbidClick: true,
				});
				
				uploadFile(formData)
					.then(response => {
						this.$toast.clear();
						if (response.code === 0) {
							// 服务器返回的是文件名
							this.applyForm.paymentVoucher = response.data;
							resolve(response.data);
						} else {
							reject(new Error(response.msg || this.i18n.t('recharge.upload_failed')));
						}
					})
					.catch(error => {
						this.$toast.clear();
						console.error('上传支付凭证失败:', error);
						reject(error);
					});
			});
		},
		submitRechargeApplication() {
			// 表单验证
			if (!this.applyForm.amount) {
				this.$toast.fail(this.i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang'));
				return;
			}
			if (!this.applyForm.fileData && !this.applyForm.paymentVoucher) {
				this.$toast.fail(this.i18n.t('recharge.please_upload_image'));
				return;
			}
			if (!this.rechargeInfo.address) {
				this.$toast.fail(this.i18n.t('recharge.qing_xian_xuan_ze_bi_zhong'));
				return;
			}

			// 如果文件已经上传到服务器（有paymentVoucher）就直接提交表单
			if (this.applyForm.paymentVoucher) {
				this.submitForm();
			} else {
				// 否则先上传文件
				this.uploadPaymentVoucher()
					.then(() => {
						this.submitForm();
					})
					.catch(error => {
						console.error('提交充值申请失败:', error);
						this.$toast.fail(error.message || this.i18n.t('recharge.ti_jiao_shi_bai'));
					});
			}
		},
		submitForm() {
			const formData = new FormData();
			// 将多种显示格式转换为统一数字格式后提交
			const numericAmount = this.convertAmountToNumber(this.applyForm.amount);
			if (!numericAmount) {
				this.$toast.fail(this.i18n.t('recharge.qing_shu_ru_chong_zhi_shu_liang'));
				return;
			}
			formData.append('Amount', numericAmount);
			formData.append('PaymentVoucher', this.applyForm.paymentVoucher);
			formData.append('Address', this.rechargeInfo.address);
			formData.append('Name', this.rechargeInfo.key);

			applyPay(formData)
				.then(response => {
					if (response.code === 0) {
						this.$toast.success(this.i18n.t('recharge.ti_jiao_cheng_gong'));
						// 清空表单
						this.applyForm.amount = '';
						this.applyForm.paymentVoucher = '';
						this.applyForm.uploadedImage = '';
						this.applyForm.fileData = null;
						this.$refs.fileInput.value = '';
						// 刷新记录
						this.initLog();
					} else {
						this.$toast.fail(response.msg || this.i18n.t('recharge.ti_jiao_shi_bai'));
					}
				})
				.catch(error => {
					console.error('提交充值申请失败:', error);
					this.$toast.fail(error.message || this.i18n.t('recharge.ti_jiao_shi_bai'));
				});
		},
		toPath(path) {
			if (path) {
				this.$route.push({
					name: path
				})
			}
		},
		getStatusClass(status) {
			// 根据充值状态设置不同的样式
			switch(status) {
				case 1: // 待处理
					return 'pending'
				case 2: // 已完成
					return 'success'
				case 3: // 已拒绝
					return 'rejected'
				default:
					return ''
			}
		},
		getStatusText(status) {
			// 根据充值状态返回对应的文本
			switch(status) {
				case 1:
					return this.i18n.t('recharge.pending')
				case 2:
					return this.i18n.t('recharge.success2')
				case 3:
					return this.i18n.t('recharge.rejected')
				default:
					return this.i18n.t('recharge.unknown')
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.recharge-page {
  .list-table {
    .point {
      &.pending {
        background-color: #ffa500; // 橙色，表示待处理
      }
      &.success {
        background-color: #4cd964; // 绿色，表示成功
      }
      &.rejected {
        background-color: #ff3b30; // 红色，表示拒绝
      }
    }
    .empty-data {
      padding: 30px 0;
      text-align: center;
      color: #999;
    }
  }
}
</style>
<style scoped>
/* 添加充值申请表单样式 */
.recharge-application {
  margin-top: 20px;
  background-color: var(--bg-color, #f5f7fa);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.application-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--text-color, #333);
  border-left: 4px solid var(--primary-color, #1989fa);
  padding-left: 10px;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-item .label {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-color, #333);
}

.required {
  color: #f44;
  margin-left: 3px;
}

.form-item input {
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--border-color, #dcdee0);
  background: var(--input-bg, #fff);
  padding: 0 15px;
  font-size: 15px;
  color: var(--text-color, #333);
  transition: border-color 0.3s;
}

.form-item input:focus {
  border-color: var(--primary-color, #1989fa);
  outline: none;
}

.conversion-preview {
  border-radius: 8px;
  background: rgba(25, 137, 250, 0.08);
  border: 1px solid rgba(25, 137, 250, 0.18);
  padding: 12px;
  color: var(--text-color, #333);
}

.conversion-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
}

.conversion-amount {
  font-size: 14px;
  line-height: 1.5;
}

.conversion-amount span {
  color: var(--primary-color, #1989fa);
  font-weight: 700;
}

.conversion-text {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
}

.conversion-text.warning {
  color: #d46b08;
}

.upload-container {
  border-radius: 8px;
  border: 1px dashed var(--border-color, #dcdee0);
  background: var(--input-bg, #fff);
  padding: 15px;
  position: relative;
}

.upload-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 8px;
  transition: background-color 0.3s;
  overflow: hidden;
}

.upload-button:hover {
  background-color: #e6e8ea;
}

.upload-button img {
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
}

.upload-button .preview-image {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  margin-bottom: 0;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-top: 10px;
}

.upload-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}

.view-btn, .remove-btn {
  border: none;
  background: none;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
}

.view-btn {
  color: var(--primary-color, #1989fa);
}

.remove-btn {
  color: #f44;
}

.form-btn {
  margin-top: 10px;
}

.form-btn button {
  width: 100%;
  height: 48px;
  background-color: var(--primary-color, #1989fa);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;
}

.form-btn button:hover {
  opacity: 0.9;
}

.form-btn button.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* 图片预览对话框样式 */
.image-preview-dialog {
  display: flex;
  justify-content: center;
}

.image-preview-dialog img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.image-dialog {
  width: 90%;
  max-width: 500px;
}

/* 充值状态样式 */
.list-table {
  .point {
    &.pending {
      background-color: #ffa500; /* 橙色，表示待处理 */
    }
    &.success {
      background-color: #4cd964; /* 绿色，表示成功 */
    }
    &.rejected {
      background-color: #ff3b30; /* 红色，表示拒绝 */
    }
  }
  .empty-data {
    padding: 30px 0;
    text-align: center;
    color: #999;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .recharge-application {
    padding: 15px;
  }
  
  .application-title {
    font-size: 16px;
  }
  
  .form-item .label {
    font-size: 14px;
  }
  
  .form-btn button {
    height: 44px;
    font-size: 15px;
  }
}
</style>
